export default Object.freeze({
  Auto: 1,
  Assisted: 2,
  HumanOnly: 3,
});
